import React from 'react';
import { Link } from 'react-router-dom';
import { BookHeart, Mail, MapPin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-900 text-stone-300 border-t border-stone-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <BookHeart size={32} className="text-rose-500" />
              <span className="text-2xl font-medium text-white">Ethernal</span>
            </div>
            <p className="text-stone-400 leading-relaxed max-w-md">
              Descubre las historias que tu familia nunca te contó. Conversaciones guiadas, guardadas en audio, texto y fotos para siempre.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/terminos" className="text-stone-400 hover:text-white transition-colors text-sm">
                  Términos y condiciones
                </Link>
              </li>
              <li>
                <Link to="/privacidad" className="text-stone-400 hover:text-white transition-colors text-sm">
                  Política de privacidad
                </Link>
              </li>
              <li>
                <a href="#cookies" className="text-stone-400 hover:text-white transition-colors text-sm">
                  Política de cookies
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-stone-400 text-sm">
                <Mail size={16} className="mt-0.5 shrink-0" />
                <a href="mailto:contacto@ethernalapp.com" className="hover:text-white transition-colors">
                  contacto@ethernalapp.com
                </a>
              </li>
              <li className="flex items-start gap-2 text-stone-400 text-sm">
                <MapPin size={16} className="mt-0.5 shrink-0" />
                <span>Madrid, España</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-stone-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-stone-500 text-sm text-center md:text-left">
              © {currentYear} Ethernal. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6">
              <a
                href="https://www.instagram.com/ethernal.recuerdos.familiares?utm_source=qr&igsh=MWpmdzB6MjFvN2l2Nw=="
                target="_blank"
                rel="noopener noreferrer"
                className="text-stone-500 hover:text-white transition-colors flex items-center gap-2"
              >
                <Instagram size={18} />
                <span className="text-sm">Instagram</span>
              </a>
              <a
                href="https://www.tiktok.com/@ethernal.recuerdos?_r=1&_t=ZN-91wuAbPkxPS"
                target="_blank"
                rel="noopener noreferrer"
                className="text-stone-500 hover:text-white transition-colors flex items-center gap-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
                </svg>
                <span className="text-sm">TikTok</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
